<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Rekam Medis" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <!-- @include('blocks.page-content-header') -->
          <Alert
            v-if="uploadSuccess"
            :alert="{
              title: 'Berhasil menyimpan retensi',
              type: 'success',
              content: `Berkas Fisik rekam medis berhasil disimpan`,
            }"
          />
          <Alert
            v-if="uploadFailed"
            :alert="{
              title: 'Gagal menyimpan retensi',
              type: 'danger',
              content: `Terjadi kesalahan pada sistem. Berkas Fisik rekam medis gagal disimpan`,
            }"
          />
          <div class="card-with-tab my-3">
            <div class="card-tab">
              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <router-link to="/pasien" class="nav-link"
                    >Data Rekam Medis</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/pasien/mutasi" class="nav-link"
                    >Mutasi Berkas</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/pasien/retensi" class="nav-link active"
                    >Upload Berkas Fisik</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />

          <div class="card card-filter-sort no-print">
            <div class="row">
              <div class="col-md-10 ">
                <!-- @each(input in filters) -->
                <!-- @include('blocks.formTemplate') -->
                <FormRow
                  :row="filters"
                  @handleChange="(e) => handleChange(e)"
                />
                <!-- @uploadeach -->
              </div>
              <div class="col-md-2">
                <!-- @each(input in sort) -->
                <!-- @include('blocks.formTemplate') -->
                <FormRow :row="sort" @handleChange="(e) => handleChange(e)" />
                <!-- @uploadeach -->
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <div class="row" v-if="rows && rows.length">
              <div class="col-md-3">
                <div class="row form-group mt-3">
                  <div class="col-md-12 d-flex flex-between">
                    <label class="mb-0 mr-3">Tampilkan</label>
                    <select class="form-control" v-model="perPage">
                      <option value="10">10 data</option>
                      <option v-if="rows.length > 10" value="25"
                        >25 data</option
                      >
                      <option v-if="rows.length > 25" value="50"
                        >50 data</option
                      >
                      <option v-if="rows.length > 50" value="100"
                        >100 data</option
                      >
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6 offset-md-3">
                <div class="form-group mt-3">
                  <input
                    type="text"
                    class="form-control with-icon-left without-label"
                    v-model="filter"
                    placeholder="Cari data di sini"
                    ref="focusMe"
                    @keydown="$event.stopImmediatePropagation()"
                  />
                  <i class="material-symbols-outlined">search</i>
                </div>
              </div>
            </div>
            <datatable
              :columns="columns"
              :per-page="10"
              :data="rows"
              :filter="filter"
              class="table table-hover responsive"
              v-if="loaded && rows.length"
            ></datatable>
            <EmptyState
              v-else-if="loaded && !rows.length"
              :data="{
                img: '/img/med.svg',
                size: 'small',
                title: `Tidak ada data Berkas Fisik dengan filter di atas'`,
                content:
                  'Tambahkan retensi dengan mengeklik tombol + Upload Berkas Fisik di atas',
              }"
            />
            <Loading v-else />
            <br />
            <p v-if="rows.length">
              Menampilkan
              {{ rows.length > parseInt(perPage) ? perPage : rows.length }} data
              dari total {{ rows.length }} data
            </p>
            <datatable-pager
              v-model="page"
              class="nav nav-tabs datatable-pager"
              type="abbreviated"
              v-if="loaded && rows.length"
            ></datatable-pager>
          </div>
        </div>
      </div>
    </div>
    <button
      v-for="row in rows"
      v-bind:key="'cancel' + row.id + Math.random(1024)"
      :id="'cancel' + row.id"
      @click="
        () => {
          cancel(row.id, `${row.no_rm} - ${row.nama}`);
        }
      "
      style="display:none"
    ></button>
    <button
      v-for="row in rows"
      v-bind:key="'upload' + row.id + Math.random(1024)"
      :id="'upload' + row.id"
      @click="
        () => {
          upload(
            row.id,
            `${row.no_rm} - ${row.nama_pasien}`,
            row.no_rm,
            row.nama_pasien,
            row.file_retensi
          );
        }
      "
      style="display:none"
    ></button>
    <div class="modal modal-confirm" id="modalDelete" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <!--  <h5 class="modal-title">Modal title</h5>  -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <h3 class="confirm-title">Delete Confirmation</h3> -->
            <img
              class="img-illustration delete-alert mb-0"
              src="/img/alert-triangle.svg"
              style="width:40%"
            />
            <p class="confirm-content mb-2">
              Apakah Anda yakin untuk membatalkan Berkas Fisik berikut?
            </p>
            <h4>{{ cancelItem.name }}</h4>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-danger"
              data-dismiss="modal"
            >
              TIDAK
            </button>
            <button
              id="btncancelItem"
              class="btn btn-danger"
              @click="
                () => {
                  confirmCancel(cancelItem.id);
                }
              "
              data-dismiss="modal"
            >
              YA
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-modal class="modal modal-confirm" id="modalUpload" size="lg">
      <template #modal-title>
        <p class="mb-1">Update Berkas Rekam Medis</p>
        <h5 class="mb-0 text-left text-primary">{{ uploadItem.name }}</h5>
      </template>
      <div class="container">
        <FormRow
          v-for="row in form"
          v-bind:key="row.colnum + String(Math.random(1023))"
          :row="row"
          @handleChange="(e) => uploadChange(e)"
        />
      </div>
      <template #modal-footer>
        <div class="w-100">
          <button
            id="btnuploadItem"
            class="btn btn-primary float-right"
            @click="
              () => {
                confirmUpload(uploadItem.id);
              }
            "
          >
            UPDATE BERKAS FISIK
          </button>
          <button
            type="button"
            class="btn btn-outline-primary mr-3 float-right"
            @click="$bvModal.hide('modalUpload')"
          >
            BATAL
          </button>
        </div>
      </template>
    </b-modal>
    <b-modal class="modal modal-confirm" id="modalUploadNew" size="lg">
      <template #modal-title>
        <p class="mb-1">Berkas Fisik Rekam Medis Baru</p>
      </template>
      <div class="container">
        <FormRow
          v-for="row in formNew"
          v-bind:key="row.colnum + String(Math.random(1023))"
          :row="row"
          @handleChange="(e) => uploadChange(e, true)"
        />
      </div>
      <template #modal-footer>
        <div class="w-100">
          <button
            id="btnuploadItemNew"
            class="btn btn-primary float-right"
            @click="
              () => {
                confirmUploadNew();
              }
            "
          >
            SIMPAN BERKAS FISIK
          </button>
          <button
            type="button"
            class="btn btn-outline-primary mr-3 float-right"
            @click="$bvModal.hide('modalUploadNew')"
          >
            BATAL
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import Loading from "@/components/Loading.vue";
import Alert from "@/components/Alert.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import EmptyState from "@/components/EmptyState.vue";
import { getFileName, getFullUrl } from "@/data/helper.js";
let data = {
  title: "Berkas Fisik Rekam Medis",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Upload Berkas Fisik",
      link: "#modalUpload",
      function: () => {},
      type: "function",
      iconLeft: "add",
    },
  ],
  breadcrumb: [],
};
let tabs = [
  { title: "DIJADWALKAN", link: "#", filter: "DIJADWALKAN", active: true },
  { title: "BERLANGSUNG", link: "#", filter: "BERLANGSUNG" },
  { title: "SELESAI", filter: "SELESAI", link: "#selesai" },
  { title: "DIBATALKAN", filter: "DIBATALKAN", link: "#selesai" },
];

// let lokasi = ["Pendaftaran","Rawat Jalan","Rekam Medis","Ophthalmic","Nurse Station","Pelayanan","Ruang Operasi","Apotik","Optik","Kasir"];
// let lokasiOption = lokasi.map((item)=>{
//   return { value:item,label:item };
// })

// let status = ["Dipinjam","Dikembalikan"];
// let statusOption = status.map((item)=>{
//   return { value:item,label:item };
// })

export let sorts = [
  {
    value: "desc",
    label: "Terbaru",
  },
  {
    value: "asc",
    label: "Terlama",
  },
];
let filters = {
  colnum: "",
  columns: [
    {
      label: "tanggal",
      type: "date",
      placeholder: "Tanggal",
      name: "created_at",
      value: "",
      mandatory: true,
      colwidth: 6,
      id: "filterDateStart",
    },
  ],
};
let sort = {
  colnum: 1,
  columns: [
    {
      label: "Sort By",
      type: "select",
      placeholder: "",
      value: "desc",
      mandatory: true,
      options: sorts,
      name: "orderBy",
    },
  ],
};
let doubleDigit = function(value) {
  let stringValue = String(value);
  if (value < 10) {
    stringValue = "0" + stringValue;
  }
  return stringValue;
};
let today = new Date();
// let time=today.getTime();
let time =
  doubleDigit(today.getHours()) +
  ":" +
  doubleDigit(today.getMinutes()) +
  ":" +
  doubleDigit(today.getSeconds());
//console.log(time);
let form = [
  {
    colnum: 2,
    class: "",
    columns: [
      {
        label: "No Rekam Medis",
        type: "text",
        placeholder: "Nomor Rekam Medis Pasien",
        name: "no_rm",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
      {
        label: "Nama Pasien",
        type: "text",
        placeholder: "Masukkan Nama Pasien",
        name: "nama_pasien",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "8",
      },
    ],
  },
  {
    colnum: 1,
    class: "",
    columns: [
      {
        label: "Berkas Fisik Rekam Medis",
        type: "file",
        placeholder: "Upload Berkas Fisik",
        name: "file_retensi",
        value: "",
        mandatory: true,
        additional: "File berekstensi .pdf,.zip,.jpg,.png maksimal 10MB",
        colwidth: "12",
      },
    ],
  },
];
let formNew = [
  {
    colnum: 2,
    class: "",
    columns: [
      {
        label: "No Rekam Medis",
        type: "text",
        placeholder: "Nomor Rekam Medis Pasien",
        name: "no_rm",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
      {
        label: "Nama Pasien",
        type: "text",
        placeholder: "Masukkan Nama Pasien",
        name: "nama_pasien",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "8",
      },
    ],
  },
  {
    colnum: 1,
    class: "",
    columns: [
      {
        label: "Berkas Fisik Rekam Medis",
        type: "file",
        placeholder: "Upload Berkas Fisik",
        name: "file_retensi",
        value: "",
        mandatory: true,
        additional: "File berekstensi .pdf,.zip,.jpg,.png maksimal 10MB",
        colwidth: "12",
      },
    ],
  },
];
export default {
  name: "PasienRetensi",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    Loading,
    Alert,
    EmptyState,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      form: form,
      formNew: formNew,
      posisi: "Rekam Medis",
      status: "",
      dgs_keluar: "",
      prognosa: "",
      tgl_keluar: "",
      jam_keluar: time,
      cancelSuccess: false,
      cancelFailed: false,
      uploadSuccess: false,
      uploadFailed: false,
      cancelItem: { id: null, name: "" },
      uploadItem: { id: null, name: "", lokasi: null, status: "" },
      loaded: false,
      data: data,
      filters: filters,
      sort: sort,
      tabs: tabs,
      allRooms: [],
      created_at: "",
      orderBy: "desc",
      kamar_pasien_kelas: "",
      kamar_pasien_nama: "",
      columns: [
        {
          label: "No. RM",
          field: "no_rm",
          headerClass: "class-in-header second-class",
        },
        { label: "Pasien", field: "nama_pasien" },
        {
          label: "",
          representedAs: (item) =>
            `<a class="btn btn-sm btn-outline-secondary btn-icon float-right" href="${item.file_retensi}" download target="_download"><i class="material-symbols-outlined">cloud_download</i></a>`,
          interpolate: true,
        },
        {
          label: "Berkas Rekam Medis",
          representedAs: (item) =>
            `<a href="${item.file_retensi}" download target="_download">${item.file_name}</a>`,
          interpolate: true,
        },
        { label: "Diupload Pada", field: "formatted_created_at" },
        { label: "Diupload Oleh", field: "updated_by" },
        {
          label: "",
          representedAs: (item) =>
            `<a class="btn btn-sm btn-outline-success btn-with-icon-left" data-toggle="modal" onclick="document.getElementById('upload${item.id}').click()"><i class="material-symbols-outlined">create</i>Update Berkas</a>`,
          interpolate: true,
        },
      ],
      filter: "",
      page: 1,
      perPage: 10,
      rows: [],
      file_retensi_lama: "",
      formSet: {
        no_rm: "",
        nama_pasien: "",
        file_retensi: "",
      },
      formNewSet: {
        no_rm: "",
        nama_pasien: "",
        file_retensi: "",
      },
      // getFullUrl:getFullUrl,
      // getFileName:getFileName
    };
  },
  methods: {
    uploadChange(e, create) {
      if (create) {
        //console.log('reset new form');
        if (e.target.type == "file") {
          this.formNewSet[e.target.name] = e.target.files[0];
        } else {
          this.formNewSet[e.target.name] = e.target.value;
        }
      } else {
        if (e.target.type == "file") {
          this.formSet[e.target.name] = e.target.files[0];
        } else {
          this.formSet[e.target.name] = e.target.value;
        }
      }
      //console.log(e.target.name);
      //console.log(this[e.target.name])
    },
    handleForm: async function(formset, form, id) {
      //console.log(this.formSet.no_rm);
      this.errors = [];
      let formData = new FormData();
      let valid = this.validateForm(formset, form);
      if (valid) {
        Object.keys(formset).forEach(function(key) {
          if (formset[key]) {
            formData.append(key, formset[key]);
          }
        });
        try {
          let result;
          if (id) {
            result = await this.$store.state.HTTP.post(
              `retensi/${id}`,
              formData
            );
          } else {
            result = await this.$store.state.HTTP.post("retensi", formData);
          }
          if (result.status == "200") {
            await this.displayList();
            this.$nextTick(() => {
              if (this.$refs.focusMe) {
                this.$refs.focusMe.focus();
              }
            });
            if (id) {
              this.$bvModal.hide("modalUpload");
            } else {
              this.$bvModal.hide("modalUploadNew");
            }
            this.uploadSuccess = true;
          } else {
            this.errors.push(result.status);
            this.uploadFailed = true;
          }
        } catch (e) {
          this.errors.push(e);
          this.uploadFailed = true;
        }
      } else {
        //console.log(valid);
      }
      this.resetAlert();
    },
    validateForm: function(formset, form) {
      let valid = true;
      let self = this;
      //console.log(formset);
      form = form.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !formset[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            column.error = "";
          }
          if (column.type == "file" || column.type == "image") {
            if (
              formset[column.name] &&
              formset[column.name] != self[column.name + "_lama"]
            ) {
              var reader = new FileReader();
              reader.onload = function(e) {
                column.value = e.target.result;
              };
              reader.readAsDataURL(formset[column.name]);
            }
          } else {
            column.value = formset[column.name];
          }
          return column;
        });
        return row;
      });
      //console.log(form);
      return valid;
    },
    async handleChange(e) {
      this[e.target.name] = e.target.value;
      await this.displayList();
      // this.$nextTick(()=>{if(this.$refs.focusMe){ this.$refs.focusMe.focus()}});
    },
    displayList: async function() {
      this.page = 1;
      this.loaded = false;
      this.errors = [];
      try {
        let params = "?per_page=99999999&";
        if (this.created_at) {
          params += `created_at=${this.created_at}&`;
        }
        if (this.orderBy) {
          params += `orderBy=${this.orderBy}`;
        }
        let result = await this.$store.state.HTTP.get(`retensi${params}`);
        //console.log(result);
        if (result.status == "200") {
          this.rows = [];
          //console.log(locations);
          //console.log(resultNew);
          //console.log(result.data.data);
          // let self = this;
          this.rows = result.data.data.map((item) => {
            //console.log(getFileName(item.file_retensi));
            //console.log(getFullUrl(this.$store.state.baseStorageURL,item.file_retensi));
            return {
              id: item.id,
              no_rm: item.no_rm,
              formatted_created_at: item.formatted_created_at,
              file_name: getFileName(item.file_retensi),
              file_retensi: getFullUrl(
                this.$store.state.baseStorageURL,
                item.file_retensi
              ),
              nama_pasien: item.nama_pasien,
              updated_at: item.formatted_updated_at,
              updated_by: item.user.name,
              status: item.status,
            };
          });
          //console.log(this.rows);
          this.loaded = true;
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
          this.loaded = true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        this.loaded = true;
      }
    },
    cancel: async function(id, name) {
      this.cancelItem = {
        id: id,
        name: name,
      };
    },
    upload: async function(id, name, no_rm, nama_pasien, file_retensi) {
      this.uploadItem = {
        id,
        name,
        no_rm,
        nama_pasien,
        file_retensi,
      };
      //console.log(this.uploadItem);
      let self = this;
      Object.keys(this.formSet).forEach(function(key) {
        //console.log(key);
        self.formSet[key] = self.uploadItem[key];
        if (key == "file_retensi") {
          self.file_retensi_lama = self.uploadItem[key];
        }
      });
      this.updateForm(this.formSet, this.form);
      this.$bvModal.show("modalUpload");
    },
    uploadNew: async function() {
      let self = this;
      //console.log('mashooku');
      Object.keys(this.formNewSet).forEach(function(key) {
        //console.log(key);
        self.formNewSet[key] = "";
      });
      this.updateForm(this.formNewSet, this.formNew, true);
      this.$bvModal.show("modalUploadNew");
    },
    updateForm(formset, form, create) {
      let self = this;
      form = form.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (formset[column.name]) {
            column.value = formset[column.name];
            if (
              create ||
              (!create && ["file", "image"].indexOf(column.type) < 0)
            ) {
              self.uploadChange(
                {
                  target: {
                    value: column.value,
                    name: column.name,
                    type: column.type,
                  },
                },
                create
              );
            }
          }
          return column;
        });
        return row;
      });
      return form;
    },
    async confirmUploadNew() {
      this.handleForm(this.formNewSet, this.formNew);
    },
    async confirmUpload(id) {
      this.handleForm(this.formSet, this.form, id);
    },
    resetAlert() {
      let self = this;
      setTimeout(function() {
        self.cancelSuccess = false;
        self.uploadSuccess = false;
        self.cancelFailed = false;
        self.uploadFailed = false;
      }, 5000);
    },
    // getFullUrl(fileUrl){
    //   //console.log(fileUrl);
    //   if(!fileUrl){
    //     return '';
    //   }
    //   if(fileUrl.indexOf('public/')>-1){
    //     var urlArr = fileUrl.split('public/');
    //     fileUrl = this.$store.state.baseStorageURL+urlArr[urlArr.length-1];
    //   }
    //   return fileUrl;
    // },
    // getFileName(fileUrl){
    //   if(!fileUrl){
    //     return '';
    //   }
    //   var urlArr = fileUrl.split('/');
    //   return urlArr[urlArr.length-1];
    // }
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    await this.displayList();
    this.$nextTick(() => {
      if (this.$refs.focusMe) {
        this.$refs.focusMe.focus();
      }
    });
    this.data.actionBtn[0].function = () => this.uploadNew();
    //let $=jQuery;
    //bootstrap.load_file($);
  },
};
</script>
